import { request } from "admin/libs/openapi";

type LoginParams = {
  delivery_client: {
    email: string;
    password: string;
    remember_me: boolean;
  };
  recaptcha_response_token?: string;
};

export type LoginResponse = {
  require_totp?: boolean;
};

/**
 * ログイン処理を行うAPI
 */
export const login = async (params: LoginParams): Promise<LoginResponse> => {
  const payload: {
    sessions: {
      email: string;
      password: string;
      remember_me: boolean;
    };
    recaptcha_response_token?: string;
  } = {
    sessions: {
      email: params.delivery_client.email,
      password: params.delivery_client.password,
      remember_me: params.delivery_client.remember_me,
    },
    recaptcha_response_token: params.recaptcha_response_token,
  };

  const response = await request("post", "/admin/delivery_clients/sessions", {
    body: payload,
  });

  // レスポンスからJSONデータを取得
  try {
    const data = await response.json();
    return data as LoginResponse;
  } catch (error) {
    console.error("Failed to parse response as JSON", error);
    return { require_totp: false } as LoginResponse;
  }
};

/**
 * TOTPコードによる認証を行うAPI
 */
export const verifyTotp = async (totpCode: string): Promise<void> => {
  const payload = {
    totp_code: totpCode,
  };

  await request("post", "/admin/delivery_clients/sessions/verify_totp", {
    body: payload,
  });
};
